import React from "react";
import PropTypes from "prop-types";
import { classes, useVoltState } from "@mqd/volt-toolbox/src";
import { LoadingOverlay } from "@mqd/volt-core/src";
import css from "./content.module.css";
export const Content = React.forwardRef(({ children }, ref) => {
  const loading = useVoltState((state) => state.loading);
  const { show, pinned } = useVoltState((state) => state.leftNav);
  return /* @__PURE__ */ React.createElement(
    "div",
    {
      className: classes(css.contentContainer, {
        [css["contentContainer--expanded"]]: show && !pinned
      }),
      ref
    },
    /* @__PURE__ */ React.createElement("main", { id: "content", className: css.content }, /* @__PURE__ */ React.createElement(
      LoadingOverlay,
      {
        active: loading,
        top: "4rem",
        size: 64,
        color: "var(--color-black-lighter-5)"
      },
      children
    ))
  );
});
Content.displayName = "Content";
Content.propTypes = {
  children: PropTypes.node
};
